export enum Scope {
    GROUP = "GROUP",
    LOCATION = "LOCATION",
    TEAMS = "TEAMS",
}
